import { motion, useMotionValue } from "motion/react";
import { useLayoutEffect } from "react";
import { createPortal } from "react-dom";

import { TOUR_SPOTLIGHT_PADDING_PX, TOUR_SPOTLIGHT_RADIUS_PX, TOUR_Z_INDEX } from "../constants";

const SPOTLIGHT_TRANSITION = { type: "spring", bounce: 0, duration: 0.3 } as const;

type TourSpotlightProps = {
  target: HTMLElement;
};

export function TourSpotlight({ target }: TourSpotlightProps) {
  const top = useMotionValue(0);
  const left = useMotionValue(0);
  const width = useMotionValue(0);
  const height = useMotionValue(0);

  useLayoutEffect(() => {
    let frame = 0;
    const follow = () => {
      const rect = target.getBoundingClientRect();
      top.set(rect.top - TOUR_SPOTLIGHT_PADDING_PX);
      left.set(rect.left - TOUR_SPOTLIGHT_PADDING_PX);
      width.set(rect.width + TOUR_SPOTLIGHT_PADDING_PX * 2);
      height.set(rect.height + TOUR_SPOTLIGHT_PADDING_PX * 2);
      frame = requestAnimationFrame(follow);
    };
    follow();
    return () => cancelAnimationFrame(frame);
  }, [target, top, left, width, height]);

  return createPortal(
    <motion.div
      aria-hidden
      initial={{ opacity: 0, scale: 1.04 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 1.04 }}
      transition={SPOTLIGHT_TRANSITION}
      style={{ top, left, width, height, zIndex: TOUR_Z_INDEX, borderRadius: TOUR_SPOTLIGHT_RADIUS_PX }}
      className="pointer-events-none fixed border-2 border-primary shadow-[0_0_9px_var(--primary)]"
    />,
    document.body,
  );
}
